import useSound from 'use-sound'
import cardDealSFX from '../../../lib/assets/audio/dealCards.mp3'
import cardClearSFX from '../../../lib/assets/audio/clearCards.mp3'
import cardFlipSFX from '../../../lib/assets/audio/cardFlip.mp3'
import winSFX from '../../../lib/assets/audio/win.mp3'
import loseSFX from '../../../lib/assets/audio/lose.mp3'

export const useGameBoardSounds = (volume?: string) => {
  const [playcardDealSFX] = useSound(cardDealSFX, {
    volume: volume ? parseFloat(volume) : 0,
  })
  const [playcardClearSFX] = useSound(cardClearSFX, {
    volume: volume ? parseFloat(volume) : 0,
  })
  const [playcardFlipSFX] = useSound(cardFlipSFX, {
    volume: volume ? parseFloat(volume) : 0,
  })
  const [playWinSFX] = useSound(winSFX, {
    volume: volume ? parseFloat(volume) : 0,
  })
  const [playLoseSFX] = useSound(loseSFX, {
    volume: volume ? parseFloat(volume) : 0,
  })

  return {
    playcardDealSFX,
    playcardClearSFX,
    playcardFlipSFX,
    playWinSFX,
    playLoseSFX,
  }
}
